// Duits (de-DE), e-mails: zelfde vorm als email.nl.ts (lijsten van regels even lang als in nl).
// De paden in de links ({origin}/instellingen/beveiliging) zijn echte adressen en blijven gelijk.
// Wat ontbreekt valt terug op het Nederlands (nooit een rauwe sleutel).
export const emailDe = {
    buttonFallback: 'Der Button funktioniert nicht? Kopiere diesen Link: {url}',
    verify: {
        subject: 'Bestätige deine E-Mail-Adresse für {product}',
        lines: [
            'Willkommen! Bestätige deine E-Mail-Adresse, um dein Familienboard nutzen zu können.',
            'Dieser Link ist 24 Stunden gültig. Du hast kein Konto erstellt? Dann ignoriere diese E-Mail.',
        ],
        cta: 'E-Mail-Adresse bestätigen',
    },
    reset: {
        subject: 'Passwort zurücksetzen',
        lines: [
            'Du hast ein neues Passwort angefordert.',
            'Dieser Link ist 60 Minuten gültig und funktioniert einmal. Du hast das nicht angefordert? Dann ignoriere diese E-Mail; dein Passwort bleibt unverändert.',
        ],
        cta: 'Neues Passwort wählen',
    },
    invitation: {
        subject: 'Einladung zum Familienboard von {household}',
        lines: [
            'Du bist eingeladen, beim Familienboard von {household} mitzumachen.',
            'Die Einladung ist 7 Tage gültig.',
        ],
        cta: 'Einladung annehmen',
    },
    // Golf 8 (0050): uitnodiging voor de familiekring. Geen woorden over gezondheid; wel dat het
    // geen alarmdienst is.
    // Golf 8 ronde 1 (ON-3): een huisgenoot uitnodigen (rol parent).
    houseInvite: {
        subject: '{inviter} lädt dich zu {household} ein',
        lines: [
            '{inviter} lädt dich zu {household} bei AMUMIN ein: Putzplan, wer mitisst, Reservierungen und geteilte Kosten, auf deinem eigenen Handy.',
            'Mitbewohner bekommen dieselben Rechte wie {inviter}.',
            'Die Einladung ist 7 Tage gültig.',
        ],
        cta: 'Einladung ansehen',
    },
    circleInvite: {
        subject: '{inviter} lädt dich zum Mitschauen ein',
        lines: [
            '{inviter} lädt dich ein, bei der Familientafel von {household} als „{label}“ mitzuschauen.',
            '{name} sagt selbst auf der Tafel, ob das in Ordnung ist. Danach siehst du nur, was {name} erlaubt.',
            'Dies ist kein Notrufdienst.',
            'Die Einladung ist 7 Tage gültig.',
        ],
        cta: 'Einladung ansehen',
    },
    existingAccount: {
        subject: 'Du hast schon ein {product}-Konto',
        lines: [
            'Jemand hat versucht, mit dieser E-Mail-Adresse ein neues Konto zu erstellen, aber es gibt schon eins.',
            'Warst du das? Dann melde dich einfach an. Passwort vergessen? Fordere über den Button unten ein neues Passwort an.',
            'Warst du das nicht? Dann musst du nichts tun; es wurde nichts geändert.',
        ],
        cta: 'Anmelden',
    },
    newLogin: {
        subject: 'Neue Anmeldung bei deinem {product}-Konto',
        lines: [
            'Am {when} gab es eine Anmeldung von einem Browser, den wir noch nicht kannten.',
            'Warst du das? Dann musst du nichts tun.',
            'Warst du das nicht? Dann ändere dein Passwort und melde dich überall ab über {origin}/instellingen/beveiliging.',
        ],
    },
    devicePaired: {
        subject: 'Tablet „{device}“ mit {room} gekoppelt',
        lines: [
            'Am {when} wurde das Tablet „{device}“ mit dem Raum {room} eures Familienboards gekoppelt.',
            'Hast du oder dein Partner das gemacht? Dann musst du nichts tun.',
            'Kommt dir das unbekannt vor? Dann widerrufe die Kopplung über {origin}/apparaten und ändere dein Passwort.',
        ],
    },
    loginCode: {
        subject: '{code} ist dein Code für {product}',
        code: 'Dein Code: {code}',
        whyNetwork: 'Du möchtest ein Netzwerk als vertrauenswürdig hinzufügen. Gib diesen Code ein, um das zu bestätigen.',
        whyLogin: 'Es gab eine Anmeldung mit deinem Passwort. Gib diesen Code im selben Browser ein; nach der Bestätigung vertrauen wir diesem Browser 30 Tage (bis {until}).',
        details: 'Browser: {browser} · Netzwerk: {network} · {when}.',
        unknown: 'unbekannt',
        validity: 'Der Code ist 10 Minuten gültig.',
        warning: 'Wir fragen nie per Telefon, Chat oder E-Mail nach diesem Code; gib ihn nur auf {host} ein.',
        cta: 'Das war ich nicht',
    },
    trustedBrowser: {
        subject: 'Neuer vertrauenswürdiger Browser für {product}',
        someBrowser: 'Ein Browser',
        lines: [
            '{browser} ist jetzt ein vertrauenswürdiger Browser, gültig bis {until}.',
            'In diesem Browser fragen wir bis dahin nicht mehr nach einem E-Mail-Code; dein Passwort brauchst du immer.',
            'Warst du das nicht? Dann ändere dein Passwort und vergiss alle Browser über {origin}/instellingen/beveiliging.',
        ],
    },
    trustedNetwork: {
        subject: '{name} hat {label} {verb}',
        verbs: {
            added: 'als vertrauenswürdiges Netzwerk hinzugefügt (noch nicht bestätigt)',
            confirmed: 'als vertrauenswürdiges Netzwerk bestätigt',
            updated: 'geändert',
            disabled: 'als vertrauenswürdiges Netzwerk ausgeschaltet',
            removed: 'aus den vertrauenswürdigen Netzwerken entfernt',
        },
        household: 'Das gilt für alle Eltern im Haushalt: Aus diesem Netzwerk fragen wir nach dem Passwort nicht nach einem E-Mail-Code.',
        identity: 'Das gilt nur für {name}.',
        check: 'Stimmt das nicht? Sieh dir die vertrauenswürdigen Netzwerke unter {origin}/instellingen/beveiliging an.',
    },
    lockout: {
        subject: 'Anmeldung mit E-Mail-Code vorübergehend gesperrt',
        lines: [
            'Es wurden zu viele Anmeldecodes angefordert oder falsch eingegeben. Bis {until} schicken wir keine neuen Codes.',
            'Warst du das nicht? Dann kennt vielleicht jemand anderes dein Passwort: Ändere es über „Passwort vergessen“.',
        ],
    },
    wanChanged: {
        subject: 'Die Internetadresse deines Servers hat sich geändert',
        lines: [
            'Am {when} hat der Server von deinem Anbieter eine neue Internetadresse bekommen.',
            'Das vertrauenswürdige Netzwerk „Thuis (WAN)“ zieht automatisch nach. Hast du das nicht erwartet? Prüfe deinen Router und die vertrauenswürdigen Netzwerke.',
        ],
    },
    recoveryReuse: {
        subject: 'Achtung: Tablet „{device}“ als verdächtig markiert',
        lines: [
            'Der Wiederherstellungstoken des Tablets „{device}“ wurde ein zweites Mal benutzt.',
            'Das Tablet ist vorübergehend als verdächtig markiert. Prüfe in der App unter Geräte, ob alles stimmt, und bestätige oder widerrufe die Kopplung.',
        ],
    },
    familyLink: {
        subject: '{name} möchte sich mit eurem Familienboard verbinden',
        lines: [
            '{name} möchte ein paar Dinge mit euch teilen, zum Beispiel Geburtstage und Wunschzettel.',
            'Ihr entscheidet danach selbst, was ihr zurück teilt. Die Einladung ist 7 Tage gültig.',
            'Noch kein {product}? Dann erstelle zuerst ein kostenloses Konto mit dieser E-Mail-Adresse.',
        ],
        cta: 'Verbindung ansehen',
    },
    billing: {
        signupCode: {
            subject: '{code} ist dein Code, um die Anmeldung abzuschließen',
            lines: [
                'Willkommen bei {product}! Dein Code lautet {code}.',
                'Gib den Code auf dem Bildschirm ein, auf dem du dich anmeldest, oder nutze den Button unten im selben Browser.',
                'Der Code ist 10 Minuten gültig, der Button 24 Stunden. Du hast dich nicht angemeldet? Dann ignoriere diese E-Mail; es passiert nichts.',
                'Wir fragen nie per Telefon, Chat oder E-Mail nach diesem Code; gib ihn nur auf {host} ein.',
            ],
            cta: 'Anmeldung abschließen',
        },
        priceLine: 'Danach kostet es {price}. Du kannst jederzeit kündigen.',
        priceUnknown: 'Was es danach kostet, sagen wir dir rechtzeitig vor dem Ende. Du kannst jederzeit kündigen.',
        perMonth: '{amount} pro Monat',
        trialWelcome: {
            subject: 'Willkommen! Dein Probemonat läuft bis einschließlich {date}',
            lines: [
                'Schön, dass ihr {product} nutzt. Der erste Monat ist kostenlos, bis einschließlich {date}.',
                'Du musst jetzt nichts bezahlen oder ausfüllen. Eine Woche vor dem Ende schicken wir eine Erinnerung.',
            ],
            cta: 'Zur App',
        },
        trialReminder7d: {
            subject: 'Noch eine Woche kostenlos: dein Probemonat läuft bis {date}',
            lines: [
                'Dein Probemonat von {product} läuft noch bis einschließlich {date}.',
                'Möchtest du danach weitermachen? Füge deine Zahlungsdaten unter Einstellungen › Abonnement hinzu.',
                'Tust du nichts, kannst du danach alles weiter ansehen, aber nichts mehr hinzufügen oder ändern. Wir löschen nichts.',
            ],
            cta: 'Abonnement ansehen',
        },
        trialReminder1d: {
            subject: 'Heute ist dein letzter kostenloser Tag',
            lines: [
                'Heute ({date}) ist der letzte Tag deines kostenlosen Monats von {product}.',
                'Möchtest du ohne Unterbrechung weitermachen? Füge heute deine Zahlungsdaten unter Einstellungen › Abonnement hinzu.',
                'Tust du nichts, ist die Tafel ab morgen nur zum Ansehen. Deine Daten bleiben erhalten.',
            ],
            cta: 'Zahlungsdaten hinzufügen',
        },
        trialExpired: {
            subject: 'Dein Probemonat ist vorbei',
            lines: [
                'Dein kostenloser Monat von {product} ist vorbei. Alles ist noch da: Du kannst den Kalender und den Rest ansehen, auch auf der Tafel.',
                'Hinzufügen und Ändern geht wieder, sobald du deine Zahlungsdaten hinzugefügt hast.',
                'Möchtest du aufhören? Dann musst du nichts tun. Wir löschen deine Daten nie von selbst; löschen kannst du sie unter Einstellungen › Deine Daten.',
            ],
            cta: 'Abonnement ansehen',
        },
        expiredFollowup: {
            subject: 'Möchtet ihr mit {product} weitermachen?',
            lines: [
                'Euer Probemonat ist vor einem Monat abgelaufen. Die Tafel ist noch nur zum Ansehen.',
                'Weitermachen geht jederzeit: Fügt eure Zahlungsdaten unter Einstellungen › Abonnement hinzu.',
                'Lieber aufhören? Dann kündigt oder löscht die Familientafel unter Einstellungen › Deine Daten. Dazu schicken wir keine E-Mail mehr.',
            ],
            cta: 'Abonnement ansehen',
        },
        cancelled: {
            subject: 'Dein Abonnement ist gekündigt',
            lines: [
                'Du hast dein Abonnement von {product} gekündigt. Bis einschließlich {date} funktioniert alles wie jetzt.',
                'Danach kannst du alles ansehen, aber nichts mehr ändern. Wir löschen nichts von selbst.',
                'Doch weitermachen? Das geht bis einschließlich {date} unter Einstellungen › Abonnement.',
            ],
            cta: 'Abonnement ansehen',
        },
    },
};
//# sourceMappingURL=email.de.js.map